export const H2 = 2;
export const H3 = 3;
export const H4 = 4;

export const HEADING_KEYBOARD_SHORTCUTS = {
  [H2]: 'ctl+2',
  [H3]: 'ctl+3',
  [H4]: 'ctl+4',
};
